
import {Stack} from "@mui/material";
import moment from "moment";
import { DateInput } from './date-input';
import React, { useEffect, useState } from 'react';
import { DateRangeInput } from '@coverright/data-access/types/enrollment';

interface FilterProps {
  value?: DateRangeInput | null,
  onChange: (value?: DateRangeInput) => void,
  label: string
}

const FORMAT = 'MM/DD/YYYY'

export const DateRange = ({value, onChange, label}: FilterProps) => {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  useEffect(() => {
    if (value) {
      if (value.from) {
        setFrom(moment(value.from).format(FORMAT));
      }
      if (value.to) {
        setTo(moment(value.to).format(FORMAT));
      }
    }
  }, [value]);

  const handleFromChange = (date: string) => {
    setFrom(date);

    if (/\d{2}\/\d{2}\/\d{4}/.test(date)) {
      const f = moment(date, FORMAT).startOf('day');
      let t = to ? moment(to, FORMAT).endOf('day') : moment().endOf('day')

      if (f.isSameOrAfter(t)) {
        t = moment(date).endOf('day')
      }

      onChange({from: f.toISOString(), to: t.toISOString()})
    }
  }

  const handleToChange = (date: string) => {
    setTo(date);

    if (/\d{2}\/\d{2}\/\d{4}/.test(date)) {
      let f = from ? moment(from, FORMAT).startOf('day') : moment(date).startOf('day');
      let t = moment(date, FORMAT).endOf('day')

      if (t.isSameOrBefore(f)) {
        f = moment(date).startOf('day')
        t = moment(date).endOf('day')
      }

      const res = {from: f.toISOString(), to: t.toISOString()}
      onChange(res)
    }
  }

  return <Stack direction={{xs: 'column', sm: 'row'}} gap={{xs: 1, sm: 2}} alignItems={{xs: 'flex-start', sm: 'center'}}>
    <DateInput hideTick
      label={label ? label + ' from' : ''}
      sx={{mt: !label ? 0 : undefined}}
      placeholder={'MM / DD / YYYY'}
      value={from}
      selectAllOnFocus
      onChange={(e) => {
        handleFromChange(e.target.value as string);
      }}
    />
    <DateInput hideTick
      label={label ? label + ' to' : ''}
      sx={{mt: !label ? 0 : undefined}}
      placeholder={'MM / DD / YYYY'}
      value={to}
      selectAllOnFocus
      onChange={(e) => {
        handleToChange(e.target.value as string);
      }}
    />
  </Stack>
}
